module.exports = __webpack_public_path__ + "img/icon_xdcj.022e65bf.png";